import { createFileRoute, redirect } from "@tanstack/react-router";
import { exigirClubeNoAr } from "@/lib/clube";

// Link curto para a lista da Turma Fundadora: nutriclaracamille.com.au/vaga abre a LP com a folha da lista (mantém as UTMs).
export const Route = createFileRoute("/vaga")({
  beforeLoad: ({ location }) => {
    exigirClubeNoAr();
    const q = new URLSearchParams(location.searchStr ?? "");
    q.set("vaga", "1");
    throw redirect({ href: `/clube?${q.toString()}`, statusCode: 302 });
  },
});
